import { render, staticRenderFns } from "./VinculoIndex.vue?vue&type=template&id=13f90a5f&"
import script from "./VinculoIndex.vue?vue&type=script&lang=js&"
export * from "./VinculoIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports